module.exports = __webpack_public_path__ + "static/logo-fmd-5d7200ef81cd5c656098c1ed48c7177c.svg";